/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CountryCode} from "./countryCode.zod";

export const PhoneNumberDto = zod.object({
  regionCode: CountryCode,
  nationalNumber: zod.string(),
});

export type PhoneNumberDto = zod.input<typeof PhoneNumberDto>;
export type PhoneNumberDtoOutput = zod.output<typeof PhoneNumberDto>;
